// extracted by mini-css-extract-plugin
export var columnList = "_a8-0";